import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Logo } from './Logo';
import ULThemeLink from './ULThemeLink';
import ULBrandBanner from './ULBrandBanner';

export interface ULThemePageLayoutProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The auth screen content rendered in the left panel.
   */
  children: ReactNode;
  /**
   * Optional class names applied to the left content area.
   * Use "theme-universal" here to enable Auth0 theme overrides on child widgets.
   */
  className?: string;
}

const ULThemePageLayout = ({ children, className, ...rest }: ULThemePageLayoutProps) => {
  return (
    <div className="min-h-screen" {...rest}>
      {/* ── Left auth panel ── scrolls independently, reserves space for fixed banner ── */}
      <div className="flex min-h-screen flex-col bg-white lg:mr-[33.333%]">
        {/* Top bar: Dot Star logo + Help link */}
        <div className="flex shrink-0 items-center justify-between px-8 py-6">
          <Logo size="sm" />
          <ULThemeLink href="mailto:help@dotstar.io">
            Not working? Get help
          </ULThemeLink>
        </div>

        {/* Auth content — vertically + horizontally centered */}
        <div
          className={cn(
            'flex flex-1 items-center justify-center px-10 pb-12',
            className
          )}
        >
          {children}
        </div>
      </div>

      {/* ── Right branding panel ── */}
      <ULBrandBanner />
    </div>
  );
};

export default ULThemePageLayout;
